import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from '../../../../utilities/requestClient';



/**
 * Fetches the dropdown options for counterparty selection
 */
export const getMancoCounterpartyDropdownData = async (): Promise<
Record<string, string>
> => {
  return (await AxiosInstance.get<Record<string, string>>(
    'manco_counterparty_gem_data/manco_cp_key_data',
  )).data;
};

/**
 * React Query hook for fetching counterparty dropdown options
 */
export function useMancoCounterpartyDropdownData() {
  return useQuery({
    queryKey: ['manco-counterparty-dropdown'],
    queryFn: () => getMancoCounterpartyDropdownData(),
    staleTime: 1000 * 60 * 30,
  });
}

/**
 * Fetches counterparty exposure data for a specific counterparty and date
 */
export const getMancoCounterpartyExposureData = async (
  counterparty: string,
  positionDate?: string,
    ): Promise<any> => {
  const url = `manco_counterparty_gem_data/counterparty/${counterparty}/${
    positionDate ? positionDate : ''
  }`;
  return (await AxiosInstance.get(url)).data;
};

/**
 * React Query hook for fetching counterparty exposure data
 */
export function useMancoCounterpartyExposureData(
  counterparty: string | null,
  positionDate?: string,
) {
  return useQuery({
    queryKey: ['manco-counterparty-exposure', counterparty, positionDate],
    queryFn: () => getMancoCounterpartyExposureData(counterparty!, positionDate),
    staleTime: 1000 * 60 * 30,
    enabled: !!counterparty && counterparty !== 'None Selected',
  });
}

